export const sfEnabled = (): boolean => {
  return import.meta.env.VITE_ENABLE_SF === 'true';
};
